<template>
	<div class="billa-app">
		<div class="billa-app--header">
			<img :src="options.header" alt="Kvalita je v nás">
		</div>

		<div class="billa-app--body">
			<div class="billa-app-row">
				<div class="billa-app--body--banner">
					<div class="billa-app--body--banner--image">
						<img :src="options.competition" alt="Odkryme naše kvality">
					</div>

					<div class="billa-app--body--banner--description">
						*Súťaž sa vzťahuje len na zamestnancov/kyne spoločnosti BILLA.
					</div>
				</div>

				<div class="billa-app--body--header">
					<div class="billa-app--body--header--row">
						<div class="billa-app-title">
							Generátor kvalitných ľudí
						</div>
					</div>

					<div class="billa-app--body--header--row">
						<div class="billa-radio-buttons">
							<div class="billa-radio-buttons--box">
								<input type="radio" id="1" name="1" :value="true" v-model="data.employee">
								<label for="1">Som zamestnanec/kyňa BILLA</label>
							</div>

							<div class="billa-radio-buttons--box">
								<input type="radio" id="2" name="2" :value="false" v-model="data.employee">
								<label for="2">Som priateľ/ka BILLA</label>
							</div>
						</div>
					</div>
				</div>
				
				<div class="billa-app--body--form">
					<div class="billa-app--body--form--col">
						<div class="billa-app-form">
							<label class="billa-app-label">
								<div class="billa-app-label--title">Nie som len ...</div>
								<input type="text" v-model="data.profession">
							</label>

							<label class="billa-app-label">
								<div class="billa-app-label--title">Som aj ...</div>
								<input type="text" v-model="data.hobby">
							</label>

							<div class="billa-app-label col-2">
								<DragAndDropFilesUpload @update="data.image = $event" />
							</div>

							<div v-if="data.employee" class="billa-app-label col-2">
								<div class="billa-app-select">
									<div class="billa-app-select--header">
										Pracujem na
									</div>

									<div class="billa-app-select--value">
										<div class="billa-app-select--value--col" @click="selectDataCenter('prev')">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor">
												<path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
											</svg>													  
										</div>

										<div class="billa-app-select--value--col">
											{{ center === 0 ? 'Vyber stredisko' : this.data.center }}
										</div>

										<div class="billa-app-select--value--col" @click="selectDataCenter('next')">
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor">
												<path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
											</svg>													  
										</div>
									</div>
								</div>

								Súťaže sa môžeš zúčastniť iba ak vyplníš svoje stredisko.
							</div>
						</div>
					</div>
					
					<div class="billa-app--body--form--col col-canvas">
						<div class="billa-app--body--form--col--row">
							<canvas ref="canvas" width="400" height="500"></canvas>
						</div>

						<div v-if="resource" class="billa-app--body--form--col--row">
							<div class="billa-app-buttons billa-app-buttons-center">
								<a :href="`${options.app_url}/${resource.folder}/sutazna_fotografia.png`" class="billa-app-button billa-app-button-yellow" download target="_blank">
									Stiahni si fotografiu
								</a>

								<a :href="`https://www.facebook.com/sharer/sharer.php?u=${options.app_url}/photo/${resource.slug}`" class="billa-app-button billa-app-button-facebook" target="_blank">
									Zdieľaj na Facebooku
								</a>
							</div>
						</div>
					</div>

					<div class="billa-app--body--form--col col-user">
						<div class="billa-app-form">
							<label class="billa-app-label">
								<div class="billa-app-label--title">Krstné meno</div>
								<input type="text" v-model="data.firstname">
							</label>

							<label class="billa-app-label">
								<div class="billa-app-label--title">Priezvisko</div>
								<input type="text" v-model="data.lastname">
							</label>

							<label class="billa-app-label">
								<div class="billa-app-label--title">
									{{ data.employee ? 'Dátum narodenia / ID zamestnanca' : 'Dátum narodenia' }}
								</div>
								<input type="text" v-model="data.birthdate">
							</label>

							<label class="billa-app-label">
								<div class="billa-app-label--title">Email</div>
								<input type="text" v-model="data.email">
							</label>
						</div>
					</div>

					<div class="billa-app--body--form--col col-approvals">
						<div class="billa-radio-buttons">
							<div v-if="options.businessConditions" class="billa-radio-buttons--box big-radio-button">
								<input type="checkbox" id="approval-1" name="approval-1" v-model="approvals.businessConditions">
								<label v-if="data.employee" for="approval-1">
									Prihlasujem sa do <a :href="options.competitionStatus" target="_blank">súťaže</a> a zároveň vyjadrujem <a :href="options.businessConditions" target="_blank">súhlas</a> s vyhotovením a spracovaním fotografie.
								</label>
								<label v-if="!data.employee" for="approval-1">
									Vyjadrujem <a :href="options.businessConditions" target="_blank">súhlas</a> s vyhotovením a spracovaním fotografie.
								</label>
							</div>

							<div v-if="options.personalDataProtection" class="billa-radio-buttons--box big-radio-button">
								<input type="checkbox" id="approval-2" name="approval-2" v-model="approvals.personalDataProtection">
								<label for="approval-2">Oboznámil/a som sa s <a :href="options.personalDataProtection" target="_blank">informáciami o ochrane osobných údajov</a> a súhlasím s nimi.</label>
							</div>

							<div v-if="options.postingRules" class="billa-radio-buttons--box big-radio-button">
								<input type="checkbox" id="approval-3" name="approval-3" v-model="approvals.postingRules">
								<label for="approval-3">Oboznámil/a som sa s <a :href="options.postingRules" target="_blank">pravidlami zverejňovania príspevkov</a> a súhlasím s nimi.</label>
							</div>
						</div>
					</div>

					<div class="billa-app--body--form--col">
						<div class="billa-app-buttons billa-app-buttons-row">
							<div v-if="!posting" class="billa-app-button" :class="shareValidation ? 'billa-app-button-green' : 'billa-app-button-disable'" @click="savePhoto()">
								{{ data.employee ? 'Zdieľaj v galérii a vyhraj' : 'Zdieľaj v galérii' }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="billa-app--gallery">
			<div class="billa-app-row">
				<div class="billa-app--gallery--header">
					<div class="billa-app-title">
						Galéria kvality
					</div>
				</div>
	
				<div v-if="object" class="billa-app--gallery--body">
					<div class="billa-app--gallery--body--grid">
						<PhotoBox v-for="item in object.data" :key="item.id" :options="options" :item="item" @updateVotes="item.votes = $event" />
					</div>

					<div v-if="object.last_page > 1" class="billa-app--gallery--body--pagination">
						<ul class="billa-app-pagination">
							<li class="billa-app-pagination--item" :class="{'active' : item.label == filter.page}" v-for="(item, index) in object.links" :key="index">
								<span class="billa-app-pagination--item--url" v-if="item.label !== '...'" @click="filter.page = item.label">
									{{ item.label }}
								</span>
								
								<span class="billa-app-pagination--item--middler" v-if="item.label === '...'">...</span>
							</li>
						</ul>
					</div>
				</div>
	
				<div class="billa-app--gallery--footer">
					<span class="billa-app-button" @click="outOfCompetition = true">
						Vymazať fotografiu a odhlásiť sa zo súťaže
					</span>
				</div>
			</div>
		</div>

		<div v-if="options.banner" class="billa-app--footer">
			<div class="billa-app-row">
				<a href="https://www.najzamestnavatel.sk/hlasovanie" target="_blank" style="display: flex;">
					<img :src="options.banner" alt="Zahlasujte za nás v ankete">
				</a>
			</div>
		</div>

		<OutOfCompetition v-if="outOfCompetition" :options="options" @closePopup="outOfCompetition = false" />

		<PhotoDetail v-if="photoDetail" :options="options" :slug="photoDetail" @closePopup="photoDetail = false" />
	</div>
</template>

<script>
	import DragAndDropFilesUpload from './components/DragAndDropFilesUpload'
	import PhotoBox from './components/PhotoBox'
	import OutOfCompetition from './components/OutOfCompetition'
	import PhotoDetail from './components/PhotoDetail'

    export default {
		components: {
			DragAndDropFilesUpload,
			PhotoBox,
			OutOfCompetition,
			PhotoDetail
		},
		props: {
			options: {
				type: Object
			}
		},
		data() {
			return {
				approvals: {
					businessConditions: false,
					personalDataProtection: false,
					postingRules: false
				},
				canvas: null,
				center: 0,
				centers: [null, 'Logistika', 'Centrála', 'Predajňa'],
				context: null,
				data: {
					center: null,
					competitionImage: null,
					email: "",
					employee: true,
					firstname: "",
					lastname: "",
					birthdate: "",
					hobby: "",
					image: null,
					profession: ""
				},
				filter: {
                    page: 1,
                    per_page: 24,
                },
				object: null,
				outOfCompetition: false,
				resource: null,
				posting: false,
				photoDetail: this.showPhotoDetail()
			}
		},
		computed: {
			shareValidation() {
				let validation = true

				if ( !this.data.firstname ) validation = false

				if ( !this.data.lastname ) validation = false

				if ( !this.data.profession ) validation = false

				if ( !this.data.hobby ) validation = false

				if ( !this.data.competitionImage ) validation = false

				if ( !this.data.email ) validation = false

				if ( !this.data.birthdate ) validation = false

				if ( this.data.employee ) {
					
					if ( !this.data.center ) validation = false
					
				}

				if ( !this.approvals.businessConditions ) validation = false

				if ( !this.approvals.personalDataProtection ) validation = false

				if ( !this.approvals.postingRules ) validation = false

				return validation
			}
		},
		created() {
			this.loadPhotos()
		},
		mounted() {
			this.canvas = this.$refs.canvas
			this.context = this.canvas.getContext('2d')

			this.drawMyImage()
		},
		methods: {
			drawMyImage() {
				// Clear the entire canvas
				this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)

				const billaLogo = `
					<svg viewBox="0 0 1330 399" width="133" height="40" xmlns="http://www.w3.org/2000/svg">
						<g fill="rgb(255, 214, 0)">
							<path d="m0 199.5v-198.6l93.8 0.3c91.6 0.4 93.9 0.4 104.7 2.6 29.6 5.8 50.4 16.8 69 36.3 17.2 18 26.8 39.6 29.6 66.5 3 28.2-6.3 63.2-23.2 87.3l-3.8 5.4 6.1 6.1c12 11.9 20.2 25.6 25.7 42.5 4.4 13.4 5.6 21.9 5.5 40.1 0 14.6-0.4 17.7-2.8 27-3.2 12.5-11.3 29.7-18.4 39-7.2 9.5-21.7 22.8-30.9 28.2-9 5.4-19.8 9.9-31 13-7.8 2.2-8.4 2.2-116 2.5l-108.3 0.4v-198.6zm175.6 93c5.2-1.5 11.4-6.7 14.1-11.8 2.1-4.2 2.8-12.9 1.3-18.2-1.6-5.7-7.7-12.7-13.2-15.1-3.8-1.6-7.8-1.9-33-2.2l-28.8-0.3v24.5 24.6h27.3c21.1 0 28.5-0.3 32.3-1.5zm-2.6-145.1c5.3-2.5 9.5-6.5 12.1-11.6 2.8-5.4 2.6-15.9-0.5-21.8-2.6-5.2-9-10.5-14.4-12-2.1-0.5-14.6-1-28.9-1h-25.3v24.6 24.5l26.3-0.3c24.2-0.3 26.5-0.5 30.7-2.4z" />
							<path d="m360 199.5v-198.5h57.5 57.5v198.5 198.5h-57.5-57.5v-198.5z" />
							<path d="m548 199.5v-198.5h57.5 57.5v146.5 146.5h38.8 38.7l-0.3 52-0.2 52h-96-96v-198.5z" />
							<path d="m791 199.5v-198.5h57.5 57.5v146.5 146.5h38.5 38.5v52 52h-96-96v-198.5z" />
							<path d="m1018 397.2c0-0.4 2.3-11.8 5-25.2 2.8-13.5 5.5-26.5 6-29s3.4-16.6 6.5-31.5c3.1-14.8 6-29 6.5-31.5 0.9-4.7 10.3-50 21.5-104.5 3.6-17.6 7-34 7.5-36.5 1.5-7.3 14.4-70.3 20.5-99.5 3.1-14.8 6.1-29.6 6.7-32.7l1-5.8h71.3c67.1 0 71.4 0.1 71.9 1.8 0.2 0.9 2.3 10 4.5 20.2 3.9 17.7 23.8 108.9 34.1 156 23.4 106.8 31.2 142.7 38.6 176.5 4.7 21.5 8.8 39.8 9 40.8 0.5 1.6-2.7 1.7-58 1.7-32.2 0-58.6-0.3-58.6-0.6 0-1.3-7-50-7.5-52.1l-0.5-2.3h-30.8-30.8l-7.8 55h-58.3c-32.1 0-58.3-0.3-58.3-0.8zm182-127.9c0-0.5-1.6-9.8-3.6-20.8-6.3-35.3-11.2-62.6-14-78.7l-2.8-15.8h-6.1-6.1l-4.8 26.8c-10.9 60.5-15.6 87.3-15.6 88.2 0 0.6 10.2 1 26.5 1 14.6 0 26.5-0.3 26.5-0.7z" />
						</g>
					</svg>
				`;

				const logo = new Image()
				const img = new Image()

				logo.src = 'data:image/svg+xml;base64,' + btoa( billaLogo )
				
				if ( this.data.image ) {
					
					img.src = this.data.image
					
					logo.onload = () => {
						img.onload = () => {
	
							//Calculate the scaling factor to cover the entire canvas
							let scale = Math.max(this.canvas.width / img.width, this.canvas.height / img.height)
							
							//Calculate the position to center the image
							let offsetX = (this.canvas.width - img.width * scale) / 2
							let offsetY = (this.canvas.height - img.height * scale) / 2
							
							this.context.drawImage(img, offsetX, offsetY, img.width * scale, img.height * scale)
		
							// Add text to the image
							this.renderTextOnCanvas()
	
							this.context.drawImage(logo, this.canvas.width - (logo.width + 24), this.canvas.height - (logo.height + 20))
		
							this.data.competitionImage = this.canvas.toDataURL('image/png')
								
						}
					}

				} else {
					
					// Add text to the image
					this.renderTextOnCanvas()

					logo.onload = () => {
						this.context.drawImage(logo, this.canvas.width - (logo.width + 24), this.canvas.height - (logo.height + 20))
					}

				}
			},
			renderTextOnCanvas() {
				const MAX_LINE_WIDTH = this.canvas.width - 48
				const LINE_HEIGHT = 40

				let INITIAL_Y_POSITION = 96
				let EXTRA_ROWS = 0

				const renderText = ( text, y ) => {
					const words = text.split(' ')
					let line = ''
					let content = []
					let row = 1

					words.forEach( word => {
						let testLine = line + word + ' '
						let metrics = this.context.measureText( testLine )
						let testWidth = metrics.width
						
						if ( testWidth <= MAX_LINE_WIDTH ) {
							line = testLine
						} else {
							line = word + ' '
							row += 1
							EXTRA_ROWS += 1
						}

						content[row] = line
					})

					content.forEach( (string, index) => {
						this.context.fillText( string, 24, this.canvas.height - y - ( LINE_HEIGHT * ( content.length - 1 - index )))
					})
				}

				this.context.textAlign = 'left'
				this.context.textBaseline = 'bottom'
				this.context.fillStyle = 'rgb(255, 214, 0)'
				
				this.context.shadowColor = 'rgba(0, 0, 0, 0.5)'
				this.context.shadowBlur = 6
				this.context.shadowOffsetX = 0
				this.context.shadowOffsetY = 0

				this.context.font = '700 32px Arial'

				renderText((this.data.hobby ? this.data.hobby : '...').replace(/\s+/g, ' ').toUpperCase(), INITIAL_Y_POSITION)
				renderText('SOM AJ', EXTRA_ROWS ? INITIAL_Y_POSITION + 40 + EXTRA_ROWS * LINE_HEIGHT : INITIAL_Y_POSITION + 40)

				this.context.font = '500 32px Arial'

				renderText('LEN ' + (this.data.profession ? this.data.profession : '...').replace(/\s+/g, ' ').toUpperCase(), EXTRA_ROWS ? INITIAL_Y_POSITION + 80 + EXTRA_ROWS * LINE_HEIGHT : INITIAL_Y_POSITION + 80)
				renderText('NIE SOM', EXTRA_ROWS ? INITIAL_Y_POSITION + 120 + EXTRA_ROWS * LINE_HEIGHT : INITIAL_Y_POSITION + 120)

				this.context.shadowColor = 'rgba(0, 0, 0, 0)'

				//Biela lišta na spodu fotografie
				this.context.strokeStyle = 'rgb(255, 255, 255)'
				this.context.lineWidth = 80
				this.context.strokeRect(0, this.canvas.height - 40, this.canvas.width, 0)
				
				this.context.font = '700 16px Arial'
				this.context.fillStyle = 'rgb(0, 0, 0)'

				this.context.fillText('#KVALITAJEVNÁS', 24, this.canvas.height - 30)
			},
			savePhoto() {
				if ( !this.approvals.businessConditions ) return alert("Musíte vyjadriť súhlas s vyhotovením a spracovaním fotografie!")

				if ( !this.approvals.personalDataProtection ) return alert("Musíte byť oboznámený s informáciami o ochrane osobných údajov a súhlasiť s nimi!")

				if ( !this.approvals.postingRules ) return alert("Musíte byť oboznámený s pravidlami zverejňovania príspevkov a súhlasiť s nimi!")

				this.posting = true

                axios.post(`${this.options.app_url}/api/resources`, this.data)
				.then( response => { 
					this.resource = response.data.resource
					this.loadPhotos()
				})
				.catch( errors => { 
					this.posting = false
					return alert( errors.response.data.message ) 
				})
			},
			loadPhotos() {
				axios.post(`${this.options.app_url}/api/resources/list`, { filter: this.filter })
                .then( response => { this.object = response.data.object })
				.catch( errors => { console.log( errors.response.data.errors ) })
			},
			selectDataCenter( step ) {
				if ( step == 'prev' ) {

					this.center = this.center > 0 ? this.center - 1 : this.centers.length - 1
					this.data.center = this.centers[ this.center ]

				} else if ( step == 'next' ) {

					this.center = this.center < this.centers.length - 1 ? this.center + 1 : 0
					this.data.center = this.centers[ this.center ]

				}
			},
			showPhotoDetail() {
				let queryString = window.location.search

				if ( queryString.includes('photo=') ) {
					let params = new URLSearchParams( queryString )
					
					return params.get('photo')
				}

				return false
			}
		},
		watch: {
            'data.image': {
                handler: function () {
                    this.drawMyImage()
                },
                deep: true
            },
			'data.profession': {
                handler: function () {
                    if ( this.timer ) {
                        clearTimeout( this.timer )
                        this.timer = null
                    }

                    this.timer = setTimeout(() => {
                        this.drawMyImage()
                    }, 500)
                },
                deep: true
            },
			'data.hobby': {
                handler: function () {
                    if ( this.timer ) {
                        clearTimeout( this.timer )
                        this.timer = null
                    }

                    this.timer = setTimeout(() => {
                        this.drawMyImage()
                    }, 500)
                },
                deep: true
            },
			'data.employee': {
                handler: function ( value ) {
                    if ( !value ) {
						this.data.email = ""
						this.data.center = null
					}

					this.drawMyImage()
                },
                deep: true
            },
			'filter.page': {
                handler: function () {
                    this.loadPhotos()
                },
                deep: true
            }

        },
    }
</script>
